import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { BrowserRouter as Router } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ConfigProvider theme={{ token: { fontFamily: '"IBM Plex Sans", system-ui, sans-serif' } }}>
      <Router>
        <App />
      </Router>
    </ConfigProvider>
  </Provider>
);
